import { UserInfoWrapper } from "@/components/UserInfo/UserInfoWrapper";
import { faHexagonExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Space, Tooltip } from "antd";
import { bool, object, string } from "prop-types";
import { useIntl } from "react-intl";

const UserDisplayName = ({
  displayName,
  userAccountEnabled = undefined,
  user = undefined,
}) => {
  const intl = useIntl();

  const displayElement = (
    <>
      <Space alignment="horizontal">
        {userAccountEnabled === false && (
          <Tooltip
            title={intl.formatMessage(
              {
                id: "general.entityIsNoLongerAvailable",
              },
              {
                entity: intl.formatMessage({
                  id: "users.user",
                }),
              }
            )}
          >
            <FontAwesomeIcon icon={faHexagonExclamation} color="red" />
          </Tooltip>
        )}
        {displayName}
      </Space>
    </>
  );

  if (user) {
    return <UserInfoWrapper user={user}>{displayElement}</UserInfoWrapper>;
  }

  return displayElement;
};

UserDisplayName.propTypes = {
  displayName: string.isRequired,
  userAccountEnabled: bool,
  user: object,
};

export default UserDisplayName;
